<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card ">
        <div class="card-header">
          <i class="fa fa-pencil"></i>
          <strong>Decision</strong>
        </div>
        <div class="card-block">
          <form>
            <fieldset disabled v-show="model.id">
              <div class="form-group">
                <label>Id</label>
                <input type="text" class="form-control" v-model="model.id">
              </div>
            </fieldset>
            <div class="form-group" :class="{'has-danger': errors.has('nome') }">
              <label class="col-form-label">Nome </label>
              <input type="text" class="form-control" name="nome" v-validate="'required'" v-model="model.name">
              <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
            </div>
            <div class="form-group" :class="{'has-danger': errors.has('identificador') }">
              <label class="col-form-label">Identificador da Decision</label>
              <input type="text" class="form-control" name="identificador" v-validate="'required'" v-model="model.dmnId" data-vv-as="identificador da Decision">
              <span v-show="errors.has('identificador')" class="form-control-feedback">{{ errors.first('identificador') }}</span>
            </div>
            <div class="form-group">
              <label lass="col-form-label">Variáveis de entrada</label>
              <v-select taggable multiple v-model="model.inputHeaders"></v-select>
            </div>
            <div class="form-group">
              <label lass="col-form-label">Variáveis de saída</label>
              <v-select taggable multiple v-model="model.outputHeaders"></v-select>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="pull-right">
            <router-link :to="'/beast/decisions'" class="btn btn-sm">
              <i class="fa fa-chevron-left"></i> Cancelar
            </router-link>
            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="save">
              <i class="fa fa-save"></i> Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import axios from 'axios'

export default {
  name: 'user',
  components: {
    vSelect
  },
  data() {
    return {
      model: {
        identifier: '',
        name: '',
        dmnId: '',
        inputHeaders: [],
        outputHeaders: []
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (id !== undefined) {
      axios.get(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id).then(response => {
        this.model = response.data
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao carregar a decision.')
      })
    }
  },
  methods: {
    save: function() {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        var id = this.$route.params.id
        if (id !== undefined) {
          this.update(id)
        } else {
          this.insert()
        }
      }
    },
    insert: function() {
      axios.post(`${process.env.BEAST_MANAGER_API_URL}decisions`, this.model)
        .then(response => {
          this.showSuccess('Decision salva com sucesso')
          this.$router.push('/beast/decisions')
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao salvar a decision.')
        })
    },
    update: function(id) {
      axios.put(`${process.env.BEAST_MANAGER_API_URL}decisions/${id}`, this.model)
        .then(response => {
          this.showSuccess('Decision alterada com sucesso')
          this.$router.push('/beast/decisions')
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao alterar a decision.')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?2875b8f6